import { mockResponses } from "./mockResponse";
import {
  getLocalOrgDetail,
  LOGIN_URL,
  redirectToRegistrationUrl,
  REGISTERTION_URL,
  isLoggedIn
} from "@/helpers/helper";
import router from "@/router";

const getDefaultState = () => {
    return {
        chatBotResponse: null,
    };
};

const state = getDefaultState();

const getters = {
    getChatBotResponse: (state) => state.chatBotResponse,
};

const mutations = {
    ["SET_CHAT_BOT_RESPONSE"](state, data) {
        state.chatBotResponse = data;
    },
    ["RESET_CHAT_BOT_RESPONSE"](state) {
        state.chatBotResponse = null;
    },
};

function buildLink(linkType) {
  if (!linkType) return null;
  const orgDetail = getLocalOrgDetail();
  const { path_acronym, customer_uid, organisation_id, location_id } = orgDetail || {};

  if(["register", "login"].includes(linkType) && isLoggedIn()) {
    return { message: "Need to logout first to access this page.", url: null };
  }
  if (linkType === "register") {
    return { url: REGISTERTION_URL(), label: "Go to Register" };
  }

  if (linkType === "login") {
    return { url: LOGIN_URL(), label: "Go to Login" };
  }

  if (linkType === "support") {
    const routeAcronym = router.currentRoute.path.split("/").filter(Boolean)[0];
    const acronym = routeAcronym || path_acronym || "";
    if (acronym === "tfm") {
      return { url: `${window.location.origin}/tfm/enquiry-form`, label: "Please click the link for further support/enquiry" };
    }
    return { url: "mailto:assist@talentfind.health", label: "assist@talentfind.health" };
  }

  if (linkType === "password") {
    const routeAcronym = router.currentRoute.path.split("/").filter(Boolean)[0];
    const acronym = path_acronym || routeAcronym || "tfm";
    return { url: isLoggedIn() ? "/change-password" : `/${acronym}/forgot`, label: "Go to Reset Password" };
  }

  const routeAcronym = router.currentRoute.path.split("/").filter(Boolean)[0];
  const acronym = routeAcronym || path_acronym || "tfm";

  if (linkType === "profile") {
    return { url: `/${acronym}/register#register-form`, label: "Go to My Profile" };
  }
  if (linkType === "jobs") {
    const jobUrl = acronym === "tfm"
      ? `/${acronym}/job-board/${customer_uid}`
      : `/public/job-board/${customer_uid}`;
    return { url: jobUrl, label: "View Job Board" };
  }
  if (linkType === "training") {
    return { url: `/${acronym}/professional-development`, label: "Explore Training & CPD" };
  }
  if (linkType === "career") {
    return { url: `/${acronym}/career-pathway`, label: "Explore Career Pathways" };
  }
  if (linkType === "news") {
    return { url: `/${acronym}#news-articles`, label: "Read Latest Articles" };
  }
  if (linkType === "about") {
    return { url: `/${acronym}`, label: "Learn More About TalentFind" };
  }
  if (linkType === "home") {
    return { url: `/${acronym}`, label: "Go to Home Page" };
  }

  return null;
}

function findResponse(message) {
  const text = message.toLowerCase();

  let bestMatch = null;
  let maxScore = 0;

  for (const item of mockResponses) {
    let score = 0;
    item.keywords.forEach(k => {
      if (text.includes(k)) score++;
    });
    if (score > maxScore) {
      maxScore = score;
      bestMatch = item;
    }
  }

  if (bestMatch) {
    const text =
      bestMatch.responses[Math.floor(Math.random() * bestMatch.responses.length)];
    if (bestMatch.linkType === "chips") {
      return { text, showChips: true };
    }
    const link = buildLink(bestMatch.linkType || null);
    if(link && link.message && !link.url) {
      return { text: link.message, link: null };
    }
    return { text, link };
  }

  return { text: "I'm not sure about that. Try asking about login, registration, or support." };
}

const actions = {
    async sendChatMessage({ state, commit }, message) {
    await new Promise(r => setTimeout(r, 600));
    return findResponse(message);
  }
};

export default {
    state,
    getters,
    mutations,
    actions
};
